module.exports = __webpack_public_path__ + "img/header.1d661758.jpg";